

const Instructions = () => {
	return (

    <p id="game instructions">
        Please hit enter to start.
        Then use &#8593; and &#8595; to play
    </p>
	)
}

export default Instructions;